<template>
    <q-card
        :inline="inline"
        :class="['card', 'q-ma-sm', {inEdit: inEdit, draggingOver: draggingOver}]"
        :style="style"
        ref="card">

        <!--<q-card-media class="media q-pa-md"-->
        <!--@dragover.native.prevent="dragover"-->
        <!--@dragleave.native="dragleave"-->
        <!--@drop.native="drop"-->
        <!--@dragenter.native="dragenter">-->
        <!--<generic-viewer :tasklet="localModel.tasklet"/>-->
        <!--</q-card-media>-->

        <q-card-main class="main full-height">
            <div class="row items-center full-height full-width "
                 @dragover.prevent="() => {}"
                 @dragleave="() => {}"
                 @dragenter="() => {}"
                 @drop="drop"
            >
                <div class="text-center">
                    Przeciągnij artykuł lub ankietę
                </div>
            </div>
            <!--<p v-if="! inEdit" v-html="localModel.description"></p>-->
            <!--<q-editor v-if="inEdit && localModel.description != null" v-model="localModel.description"/>-->
        </q-card-main>

    </q-card>
</template>

<script>
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QField from 'quasar-framework/src/components/field/QField'
    import GenericViewer from './viewers/GenericViewer'
    import QCard from 'quasar-framework/src/components/card/QCard'

    export default {
        name: 'TaskletPlaceholderComponent',
        components: {
            QCard,
            GenericViewer,
            QField,
            QEditor,
            QBtn,
            QIcon,
            QCardActions,
            QCardMain,
            QCardMedia,
            QCardTitle,
        },
        props: ['model', 'editable', 'inEdit', 'inline'],
        methods: {
            dragenter () {

            },
            dragover () {
                // if (this.inEdit) {
                //     this.draggingOver = true
                // }
            },
            dragleave () {
                // if (this.inEdit) {
                //     this.draggingOver = false
                // }
            },
            drop (e) {
                e.preventDefault()

                try {
                const tasklet = JSON.parse(e.dataTransfer.getData('text'))
                    if (tasklet.type === 'article' || tasklet.type === 'survey') {
                        this.$emit('dropped', tasklet)
                    }
                // inline
                } catch (ee) {
                    // ...
                }

                this.draggingOver = false
            },
        },
        data () {
            return {
                draggingOver: false,
                isNew: false,
            }
        },
        mounted () {

        },
        computed: {
            style () {
                return ''
            },
        },
    }
</script>

<style scoped lang="scss">
    .card {
        border-radius: 20px;
        border: 3px dashed gray;

        width: 350px;
        height: 250px;
        overflow: hidden;
        position: relative;

        .media {

        }

        .main {

        }
    }

</style>
